// extracted by mini-css-extract-plugin
module.exports = {"menuMargin":"Navigation-module--menuMargin--1E8OL"};